import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core';
import React from 'react';
import propTypes from 'prop-types';
import Genre from '../../genre';

const UpdateGenreDialog = ({isOpen, handleClose, assetToUpdate, onGenresSelection}) => (
  <Dialog fullWidth={true} maxWidth="md" open={isOpen} onClose={handleClose}>
    <DialogTitle>Update Genre</DialogTitle>
    <DialogContent>
      <DialogContentText style={{fontSize: 13}}>
        <>
          <Genre assetCategory={assetToUpdate?.category} isSelect={true} onGenresSelection={onGenresSelection} />
        </>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={handleClose}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default UpdateGenreDialog;

UpdateGenreDialog.propTypes = {
  assetToUpdate: propTypes.object,
  handleClose: propTypes.func,
  isOpen: propTypes.bool,
  onGenresSelection: propTypes.func,
};
